<disclaimer [message]="'MAINTENANCES.TABS.NEW_DEADLINES.INFO' | translate"></disclaimer>

<div class="field-dialog__content__scroll p-24 tab-new-deadline with-disclaimer" fxLayout="column" fusePerfectScrollbar>
  <div class="tab-new-deadline__without-deadlines" *ngIf="!maintenance.firstVisitDeadlineAt && !maintenance.deadlineAt">
    <mat-icon>highlight_off</mat-icon>
    <p class="tab-new-deadline__without-deadlines-title">
      {{ 'MAINTENANCES.TABS.NEW_DEADLINES.WITHOUT' | translate }}
    </p>
  </div>

  <ng-container *ngIf="maintenance.firstVisitDeadlineAt || maintenance.deadlineAt">
    <ng-container *ngIf="maintenance.firstVisitDeadlineAt">
      <p class="tab-new-deadline_title mt-0">
        {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.RESPONSE_TITLE' | translate }}
      </p>

      <div class="tab-new-deadline__grid tab-new-deadline__grid--three">
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.RESPONSE_DEADLINE_DATE' | translate }}
          </p>
          <p class="tab-new-deadline__input-value">
            {{ maintenance.firstVisitDeadlineAt | date: 'dd/MM/yyyy HH:mm' }}
          </p>
        </div>
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.COMPLETED_AT' | translate }}
          </p>
          <p class="tab-new-deadline__input-value">
            {{
              maintenance.firstVisitStartedAt
                ? (maintenance.firstVisitStartedAt | date: 'dd/MM/yyyy HH:mm')
                : ('MAINTENANCES.TABS.NEW_DEADLINES.DATA.WAITING_DEADLINE' | translate)
            }}
          </p>
        </div>
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.SITUATION' | translate }}
          </p>
          <p
            class="tab-new-deadline__input-value"
            [ngClass]="'tab-new-deadline__input-value--' + (maintenance.responseDeadlineStatus | camelToKebabCase)"
          >
            {{ maintenance.responseDeadlineStatus | translateMaintenanceDeadlineStatus }}
          </p>
        </div>
      </div>

      <fc-deadline-violation-reason-input
        *ngIf="maintenanceDeadlineContract && isAllowToEditResponseViolationReason"
        [control]="newDeadlineForm.get('responseDeadlineViolationReason')"
        [deadlineContractId]="maintenanceDeadlineContract.originalContract.id"
        class="mt-24"
      ></fc-deadline-violation-reason-input>

      <div
        *ngIf="maintenanceDeadlineContract && !isAllowToEditResponseViolationReason"
        class="tab-new-deadline__input mt-24"
      >
        <p class="tab-new-deadline__input-title">
          {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_VIOLATION_REASON.TITLE' | translate }}
        </p>
        <p
          class="tab-new-deadline__input-value"
          [innerHTML]="
            maintenanceDeadlineContract.responseDeadlineViolationReason
              ? ('MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_VIOLATION_REASON.LINKED_BY_COMPANY'
                | translate
                  : {
                      name: maintenanceDeadlineContract.responseDeadlineViolationReason.deadlineViolationReason.name
                    })
              : ('MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_VIOLATION_REASON.NO_VIOLATED' | translate)
          "
        ></p>
      </div>
    </ng-container>

    <ng-container *ngIf="maintenance.deadlineAt">
      <p class="tab-new-deadline_title">
        {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.SOLUTION_TITLE' | translate }}
      </p>

      <div class="tab-new-deadline__grid tab-new-deadline__grid--three">
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.SOLUTION_DEADLINE_DATE' | translate }}
          </p>
          <p class="tab-new-deadline__input-value">
            {{ maintenance.deadlineAt | date: 'dd/MM/yyyy HH:mm' }}
          </p>
        </div>
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.COMPLETED_AT' | translate }}
          </p>
          <p class="tab-new-deadline__input-value">
            {{
              maintenance.closedAt
                ? (maintenance.closedAt | date: 'dd/MM/yyyy HH:mm')
                : ('MAINTENANCES.TABS.NEW_DEADLINES.DATA.WAITING_DEADLINE' | translate)
            }}
          </p>
        </div>
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.SITUATION' | translate }}
          </p>
          <p
            class="tab-new-deadline__input-value"
            [ngClass]="'tab-new-deadline__input-value--' + (maintenance.solutionDeadlineStatus | camelToKebabCase)"
          >
            {{ maintenance.solutionDeadlineStatus | translateMaintenanceDeadlineStatus }}
          </p>
        </div>
      </div>

      <fc-deadline-violation-reason-input
        *ngIf="maintenanceDeadlineContract && isAllowToEditSolutionViolationReason"
        [control]="newDeadlineForm.get('solutionDeadlineViolationReason')"
        [deadlineContractId]="maintenanceDeadlineContract.originalContract.id"
        class="mt-24"
      ></fc-deadline-violation-reason-input>

      <div
        *ngIf="maintenanceDeadlineContract && !isAllowToEditSolutionViolationReason"
        class="tab-new-deadline__input mt-24"
      >
        <p class="tab-new-deadline__input-title">
          {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_VIOLATION_REASON.TITLE' | translate }}
        </p>
        <p
          class="tab-new-deadline__input-value"
          [innerHTML]="
            maintenanceDeadlineContract.solutionDeadlineViolationReason
              ? ('MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_VIOLATION_REASON.LINKED_BY_COMPANY'
                | translate
                  : {
                      name: maintenanceDeadlineContract.solutionDeadlineViolationReason.deadlineViolationReason.name
                    })
              : ('MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_VIOLATION_REASON.NO_VIOLATED' | translate)
          "
        ></p>
      </div>
    </ng-container>

    <ng-container *ngIf="maintenanceDeadlineContract">
      <p class="tab-new-deadline_title">
        {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.TITLE' | translate }}
      </p>

      <div class="tab-new-deadline__grid tab-new-deadline__grid--three tab-new-deadline__grid--three--first-large">
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.NAME' | translate }}
          </p>
          <p class="tab-new-deadline__input-value">
            {{ maintenanceDeadlineContract.name }}
          </p>
        </div>
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.OFFICE_HOURS.TITLE' | translate }}
          </p>
          <p class="tab-new-deadline__input-value">
            {{
              (maintenanceDeadlineContract.hasCustomInterval
                ? 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.OFFICE_HOURS.CUSTOM'
                : 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.OFFICE_HOURS.FULLTIME'
              ) | translate
            }}
          </p>
        </div>
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.CONSIDER_HOLIDAYS.TITLE' | translate }}
          </p>
          <p class="tab-new-deadline__input-value">
            {{
              (maintenanceDeadlineContract.considerHoliday
                ? 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.CONSIDER_HOLIDAYS.YES'
                : 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.CONSIDER_HOLIDAYS.NO'
              ) | translate
            }}
          </p>
        </div>
      </div>

      <div class="tab-new-deadline__grid tab-new-deadline__grid--four mt-24">
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.RESPONSE_RISK_AFTER' | translate }}
          </p>
          <p class="tab-new-deadline__input-value">
            {{ maintenanceDeadlineContract.responseRisk.valueInMinutes | deadlineTimePipe }}
          </p>
        </div>
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.RESPONSE_TIME' | translate }}
          </p>
          <p class="tab-new-deadline__input-value">
            {{ maintenanceDeadlineContract.responseDeadline.valueInMinutes | deadlineTimePipe }}
          </p>
        </div>
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.SOLUTION_RISK_AFTER' | translate }}
          </p>
          <p class="tab-new-deadline__input-value">
            {{ maintenanceDeadlineContract.solutionRisk.valueInMinutes | deadlineTimePipe }}
          </p>
        </div>
        <div class="tab-new-deadline__input">
          <p class="tab-new-deadline__input-title">
            {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.SOLUTION_TIME' | translate }}
          </p>
          <p class="tab-new-deadline__input-value">
            {{ maintenanceDeadlineContract.solutionDeadline.valueInMinutes | deadlineTimePipe }}
          </p>
        </div>
      </div>

      <ng-container *ngIf="maintenanceDeadlineContract.hasCustomInterval">
        <p class="tab-new-deadline_title">
          {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.CUSTOM_INTERVAL.TITLE' | translate }}
        </p>

        <div class="tab-new-deadline__card">
          <div class="tab-new-deadline__card__item" *ngFor="let interval of customInterval">
            <p class="tab-new-deadline__card__item-title">
              {{
                'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.CUSTOM_INTERVAL.WEEKDAYS.' + interval.day
                  | translate
              }}&nbsp;-&nbsp;
            </p>
            <p
              *ngIf="!interval || !interval.start || !interval.end"
              class="tab-new-deadline__card__item-not-considered"
            >
              {{ 'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.CUSTOM_INTERVAL.NOT_CONSIDERED' | translate }}
            </p>
            <p *ngIf="interval.start && interval.end" class="tab-new-deadline__card__item-time">
              {{
                'MAINTENANCES.TABS.NEW_DEADLINES.DATA.DEADLINE_CONTRACT.CUSTOM_INTERVAL.TIME'
                  | translate
                    : {
                        start: interval.start,
                        end: interval.end
                      }
              }}
            </p>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
